import React from 'react'
import TrainingsStep from '../../components/Projects/Steps/TrainingsStep'

const TrainingsStepPage = () => {
  return (
    <div>
      <TrainingsStep/>
    </div>
  )
}

export default TrainingsStepPage